module.exports = new __parcel__URL__("seahorse-ios7.a7a14216.webp").toString();